exports.userService = require('./user');
exports.termService = require('./terms');
exports.payoutService = require('./payout');
exports.supportService = require('./support');
exports.orderService = require('./order');
exports.reportService = require('./reports');
exports.settingService = require('./settings');
exports.transactionService = require('./transaction');
exports.logisticService = require('./deliveryMan');
